import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { StatusBarModule } from 'Angular/features/components/loaders/status-bar/status-bar.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { HoldingsOverviewModule } from 'SecuritiesApp/ts/features/holdings-overview/holdings-overview.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { SaveAsWatchlistButtonModule } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.module';
import { HelpModalWithTriggerComponent } from 'Angular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { HoldingsOverviewComponent } from 'SecuritiesApp/ts/features/holdings-overview/holdings-overview.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { SaveAsWatchlistButton } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.component';
import { getLogger } from 'Angular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    HelpModalWithTriggerComponent,
    PieChartComponent,
    TopBarNavComponent,
    SideMenuComponent,
    SaveAsWatchlistButton,
    SecurityHeaderControlComponent,
    HoldingsOverviewComponent,
];
export class MutualFundsFundsHoldingsOverviewModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [HelpModalWithTriggerComponent, PieChartComponent, SaveAsWatchlistButton];
    }
}
MutualFundsFundsHoldingsOverviewModule.ɵfac = function MutualFundsFundsHoldingsOverviewModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsFundsHoldingsOverviewModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsFundsHoldingsOverviewModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsFundsHoldingsOverviewModule });
MutualFundsFundsHoldingsOverviewModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ConfigModule,
        BrowserModule,
        SaveAsWatchlistButtonModule,
        NavigationModule,
        PieChartModule,
        SecurityHeaderControlModule,
        StatusBarModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        SideMenuModule,
        HoldingsOverviewModule] });
